import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hidden sm:block" }
const _hoisted_2 = {
  key: 0,
  class: "text-cool-gray-700 text-sm"
}
const _hoisted_3 = {
  key: 1,
  class: "text-cool-gray-700 text-sm"
}
const _hoisted_4 = {
  key: 2,
  class: "text-cool-gray-700 text-sm"
}
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = {
  key: 3,
  class: "text-cool-gray-700 text-sm"
}
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "font-medium" }
const _hoisted_10 = { class: "flex flex-1 justify-between gap-4 sm:justify-end" }

import { nextTick, ref } from 'vue'
import { getScrollParent } from '@/helpers/getScrollParent'


export default {
  __name: 'NeuePagination',
  props: ['from', 'to', 'size'],
  emits: ['prev', 'next'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const el = ref(null)

const ret = async oldTop => {
  await nextTick()
  const newTop = el.value.getBoundingClientRect().top
  getScrollParent(el.value).scrollBy(0, newTop - oldTop)
}

const changePage = direction => {
  emit(direction, () => ret(el.value.getBoundingClientRect().top))
}

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")

  return (_openBlock(), _createElementBlock("nav", {
    ref_key: "el",
    ref: el,
    class: "mt-4 flex items-center justify-between"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (props.size === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Showing ", -1),
            _createElementVNode("span", { class: "font-medium" }, "0", -1),
            _createTextVNode(" results ", -1)
          ]))]))
        : (props.size === 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Showing ", -1),
              _createElementVNode("span", { class: "font-medium" }, "1", -1),
              _createTextVNode(" result ", -1)
            ]))]))
          : (props.from === 1 && props.to >= props.size)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _cache[4] || (_cache[4] = _createTextVNode(" Showing all of ", -1)),
                _createElementVNode("span", _hoisted_5, _toDisplayString(props.size), 1),
                _cache[5] || (_cache[5] = _createTextVNode(" results ", -1))
              ]))
            : (props.size > 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createTextVNode(" Showing ", -1)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(props.from), 1),
                  _cache[7] || (_cache[7] = _createTextVNode(" to ", -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(Math.min(props.to, props.size)), 1),
                  _cache[8] || (_cache[8] = _createTextVNode(" of ", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(props.size), 1),
                  _cache[9] || (_cache[9] = _createTextVNode(" results ", -1))
                ]))
              : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_NeueButton, {
        type: props.from !== 1 ? 'secondary' : 'inactive',
        onClick: _cache[0] || (_cache[0] = $event => (changePage('prev')))
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode("Previous", -1)
        ]))]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_NeueButton, {
        type: props.to < props.size ? 'secondary' : 'inactive',
        onClick: _cache[1] || (_cache[1] = $event => (changePage('next')))
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
          _createTextVNode("Next", -1)
        ]))]),
        _: 1
      }, 8, ["type"])
    ])
  ], 512))
}
}

}